<template>
  <div>
    <form-wizard
      color="#010022"
      :title="null"
      :subtitle="null"
      layout="vertical"
      finish-button-text="Modifier"
      back-button-text="Précédant"
      next-button-text="suivant"
      class="wizard-vertical mb-3"
      @on-complete="updateAgent"
    >
      <!-- account datails tab -->
      <tab-content title="Agent">
        <b-row>
          <b-col cols="12" class="mb-2">
            <h5 class="mb-0">Agent</h5>
            <small class="text-muted">
              Information général sur le Agent.
            </small>
          </b-col>
          <b-col md="6">
            <b-form-group label="first Name" label-for="v-nom">
              <b-form-input
                id="v-nom"
                placeholder="first Name"
                v-model="agent.firstName"
              />
            </b-form-group>
          </b-col>
          <b-col md="6">
            <b-form-group label="last Name" label-for="v-prenom">
              <b-form-input
                id="v-prenom"
                placeholder="last Name"
                v-model="agent.lastName"
              />
            </b-form-group>
          </b-col>
          <b-col md="12">
            <b-form-group label="Email" label-for="v-email">
              <b-form-input
                id="v-email"
                placeholder="Email"
                v-model="agent.user.email"
              />
            </b-form-group>
          </b-col>
          <b-col md="12">
            <b-form-group label="phone Number" label-for="v-numero">
              <b-form-input
                id="v-numero"
                placeholder="phone Number"
                v-model="agent.phoneNumber"
              />
            </b-form-group>
          </b-col>
        </b-row>
      </tab-content>

      <!-- personal info tab -->
      <tab-content title="Agent address">
        <b-row>
          <b-col cols="12" class="mb-2">
            <h5 class="mb-0">Agent address</h5>
            <small class="text-muted">Detailed agent address</small>
          </b-col>
          <b-col md="8">
            <b-form-group label="Country" label-for="v-ville">
              <b-form-input
                id="v-ville"
                placeholder="Country"
                v-model="agent.country"
              />
            </b-form-group>
          </b-col>
          <b-col md="4">
            <b-form-group label="City" label-for="v-cp">
              <b-form-input
                id="v-cp"
                placeholder="City"
                v-model="agent.city"
              />
            </b-form-group>
          </b-col>
          <b-col md="12">
            <b-form-group label="Address" label-for="v-adresse">
              <b-form-input
                id="v-adresse"
                placeholder="Address"
                v-model="agent.address"
              />
            </b-form-group>
          </b-col>
        </b-row>
      </tab-content>
      <tab-content title="Other informations">
        <b-row>
          <b-col cols="12" class="mb-2">
            <h5 class="mb-0">Other informations</h5>
            <small class="text-muted">Other informations</small>
          </b-col>
          <b-col md="6">
            <b-form-group label="Company" label-for="v-Company">
              <b-form-input
                id="v-Company"
                placeholder="Company"
                v-model="agent.company"
              />
            </b-form-group>
          </b-col>
          <b-col md="6">
            <b-form-group
              label="Tax Registration Number"
              label-for="v-taxRegistrationNumber"
            >
              <b-form-input
                id="v-taxRegistrationNumber"
                placeholder="Tax Registration Number"
                v-model="agent.taxRegistrationNumber"
              />
            </b-form-group>
          </b-col>
            <b-col md="12">
            <b-form-group
              label="vat Number"
              label-for="v-vatNumber"
            >
              <b-form-input
                id="v-vatNumber"
                placeholder="vat Number"
                v-model="agent.vatNumber"
              />
            </b-form-group>
          </b-col>
            <!-- <b-col md="6">
            <b-form-group
              label="sea Port"
              label-for="v-seaPort"
            >
              <b-form-input
                id="v-seaPort"
                placeholder="sea Port"
                v-model="agent.seaPort"
              />
            </b-form-group>
          </b-col> -->
        </b-row>
      </tab-content>
    </form-wizard>
  </div>
</template>

<script>
import VueBarcode from "vue-barcode";
import axios from "axios";
import { FormWizard, TabContent } from "vue-form-wizard";
import vSelect from "vue-select";
import "vue-form-wizard/dist/vue-form-wizard.min.css";
import {
  BImg,
  BRow,
  BCol,
  BInputGroup,
  BInputGroupPrepend,
  BInputGroupAppend,
  BFormGroup,
  BFormFile,
  BFormInput,
  BFormTextarea,
  BForm,
  BButton,
} from "bootstrap-vue";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import Ripple from "vue-ripple-directive";

export default {
  components: {
    BButton,
    BForm,
    VueBarcode,
    BImg,
    BFormFile,
    BInputGroup,
    BInputGroupPrepend,
    BInputGroupAppend,
    BFormTextarea,
    FormWizard,
    TabContent,
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    vSelect,
    // eslint-disable-next-line vue/no-unused-components
    ToastificationContent,
  },
  directives: {
    Ripple,
  },
  data() {
    return {

      agent: {
      },
    };
  },
  mounted() {
    axios
      .get(
        "https://mtl-feeder-nodejs.onrender.com/api/agents?id=" +
          this.$router.history.current.query.id
      )
      .then((response) => {
        console.log("eeee",response);
        this.agent = response.data.data[0];
      })
      .catch((error) => {
        this.errorMessage = error.message;
      });

  },
  methods: {

    updateAgent() {
      axios
        .put(
          "https://mtl-feeder-nodejs.onrender.com/api/users/" +
            this.agent.user._id,
          this.agent
        )
        .then((response) => {
          console.log(response);
          this.$toast({
            component: ToastificationContent,
            props: {
              title: "Agent updated ",
              icon: "EditIcon",
              variant: "success",
            },
          });
          this.$router.replace("/agents");
        })
        .catch((error) => {
          this.errorMessage = error.message;
        });
    },
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-wizard.scss";
@import "@core/scss/vue/libs/vue-select.scss";
.repeater-form {
  overflow: hidden;
  transition: 0.35s height;
}
</style>
